module.exports = __webpack_public_path__ + "static/img/book.dd7f253d.jpeg";